import React from 'react';
import { Section } from '../Section';
import { FadeUp } from '../FadeUp';
import { HERO_IMAGE } from '../../data/images';
export function Hero() {
  return <Section className="pt-10 md:pt-14" data-id="element-147" data-mp="7yui8063pmzp">
      <FadeUp className="flex flex-col items-center text-center" data-id="element-148" data-mp="cvbczd7t2zlr">
        <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-149" data-mp="cy7cv737rycu">
          Happy Parenting
        </p>

        <h1 className="mt-6 text-[30px] font-extrabold md:text-[46px]" data-id="element-150" data-mp="muk6y62o8e84">
          Turn <em className="italic text-pain" data-id="element-151" data-mp="qvm5slsoeo9k">yelling and meltdowns</em> into{' '}
          <span className="text-gain" data-id="element-152" data-mp="qtj5n8xt7er4">calm routines</span> with this{' '}
          <span className="underline decoration-2 underline-offset-[6px]" data-id="element-153" data-mp="vnnig8trah04">visual method</span>, in
          less than 24 hours.
        </h1>

        <img src={HERO_IMAGE} alt="The Positive Parenting Mega Kit box filled with printable routine charts" width={1063} height={1500} loading="eager" decoding="async" fetchPriority="high" className="mt-8 block h-auto w-full max-w-[420px]" style={{
        filter: 'drop-shadow(0 22px 26px rgba(20,17,15,0.18))'
      }} data-id="element-154" data-mp="15kidghqtlz9n" />

        <p className="mt-8 text-[13px] text-ink/55" data-id="element-155" data-mp="3vur92uz2bmz9">
          <span className="text-star" data-id="element-156" data-mp="3vvj341d0hcnf">★★★★★</span>&nbsp;&nbsp;Trusted by thousands of families
        </p>
      </FadeUp>
    </Section>;
}